import type React from 'react';
import { BORDERS, SPACING, TYPOGRAPHY } from '../../../../constants/design';
import { useColors } from '../../../../contexts/ThemeContext';

interface FontFamilyPreviewProps {
  family: 'default' | 'serif' | 'monospace';
  size?: number;
}

export const FontFamilyPreview: React.FC<FontFamilyPreviewProps> = ({ family, size = 48 }) => {
  const tokens = useColors();

  // Map font family values to actual TYPOGRAPHY.fontFamily values
  const getFontFamily = () => {
    switch (family) {
      case 'serif':
        return TYPOGRAPHY.fontFamily.serif;
      case 'monospace':
        return TYPOGRAPHY.fontFamily.mono;
      default:
        return TYPOGRAPHY.fontFamily.primary;
    }
  };

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        padding: SPACING.xs,
        border: `${BORDERS.width.thin} solid ${tokens.border.primary}`,
        borderRadius: BORDERS.radius.sm,
        background: tokens.surface.container,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: getFontFamily(),
        fontSize: TYPOGRAPHY.fontSize.xs,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        color: tokens.text.primary,
        textAlign: 'center',
        boxSizing: 'border-box',
        flexShrink: 0,
      }}
    >
      Aa
    </div>
  );
};
